// Copyright (c) 2025. CYBERKOALA LLC.
//
// SPDX-License-Identifier: Proprietary License.
//
// Redistribution and use in source and binary forms, with or without
// modification, are restricted.

import { CompassIcon } from 'lucide-react';
import { ActionTooltip } from '../action-tooltip';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

export const NavigationServerDiscovery = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <ActionTooltip
      side="right"
      align="center"
      label={t('NavigationServerDiscovery.tooltip')}
    >
      <button
        onClick={() => navigate(`/discovery`)}
        className="group flex items-center"
      >
        <div className="mx-3 flex size-[48px] items-center justify-center overflow-hidden rounded-[24px] bg-background transition-all group-hover:rounded-[16px] group-hover:bg-black dark:bg-neutral-700">
          <CompassIcon
            className="text-black transition hover:rotate-45 group-hover:text-white dark:text-white"
            size={25}
          />
        </div>
      </button>
    </ActionTooltip>
  );
};
